import { IForm } from 'core-components/classes/models/IForm'

interface IGetContactDetails {
  contact: IForm
}

export function getContactDetails({ contact }: IGetContactDetails) {
  return [
    {
      label: 'Contact ID',
      value: contact.ContactID || '-',
    },
    {
      label: 'Learner ID',
      value: contact.LearnerID || '-',
    },
    {
      label: 'Gender',
      value: contact.Salutation || '-',
    },
    {
      label: 'First Name',
      value: contact.FirstName || '-',
    },
    {
      label: 'Last Name',
      value: contact.LastName || '-',
    },
    {
      label: 'HP Roles',
      value: (contact.PR_HP_ROLE || '').replace(/;/g, ', ') || '-',
    },
    {
      label: 'Seniority',
      value: contact.Seniority || '-',
    },
    {
      label: 'Job Function',
      value: (contact.PrimaryJobRole || '').replace(/;/g, ', ') || '-',
    },
    {
      label: 'Location ID',
      value: contact.LocationID || '-',
    },
  ]
}
